<template>
  <div style="height: 100%; overflow-y: hidden" :key="compKey">
    <v-toolbar dark color="primary" flat dense>
      <v-icon small title="Back" v-if="showBack" @click="handleBack">mdi-arrow-left</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="body-1">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon small title="Close" @click="close(); $emit('close')">mdi-close</v-icon>
    </v-toolbar>
    <v-divider></v-divider>
    <div style="height: calc(100% - 48px); overflow-y: auto" :style="{maxHeight: CONFIG.config.infoPopup ? '200px' : 'none'}">
      <layer-list v-if="showLayerList"></layer-list>
      <object-list v-if="showObjectList"></object-list>
      <feature-info v-if="showFeatureInfo"></feature-info>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapState } from 'vuex';
  import LayerList from './infoQuery/LayerList';
  import ObjectList from './infoQuery/ObjectList';
  import FeatureInfo from './infoQuery/FeatureInfo';

  export default {
    name: 'infoQuery',
    components: {
      FeatureInfo,
      ObjectList,
      LayerList
    },
    computed: {
      ...mapState('featureInfo', {
        RESULTS: 'results',
        LAYER: 'selectedLayer',
        FEATURE: 'selectedFeature',
      }),
      ...mapGetters(['CONFIG']),
      showBack () {
        if (this.showLayerList){
          return null
        }

        if (this.showObjectList){
          //If there are other layers
          if (this.layers > 1){
            return 'layers'
          }
        }

        if (this.showFeatureInfo){
          //If there are more results
          if (this.RESULTS[this.LAYER].features.length > 1){
            return 'objects'
          }

          //Or just other layers
          if (this.layers > 1){
            return 'layers'
          }
        }
      },
      title() {
        if (this.showLayerList) {
          return this.CONFIG.config.layerListText || 'Layers';
        }
        if (this.showObjectList) {
          return this.CONFIG.config.objectListText || 'Objects';
        }
        if (this.showFeatureInfo) {
          return this.RESULTS[this.LAYER].title || this.CONFIG.config.attributeInfoText || 'Attributes';
        }
      },
      layers() {
        return this.RESULTS.length;
      },
      showLayerList() {
        return this.layers > 1 && this.LAYER === null;
      },
      showObjectList() {
        return this.LAYER !== null && this.RESULTS[this.LAYER].features.length > 1 && !this.showFeatureInfo;
      },
      showFeatureInfo() {
        return this.FEATURE !== null;
      },
    },

    beforeDestroy () {
      this.$store.commit('featureInfo/CLEAR_QUERY');
    },

    methods: {
      close() {
        console.log("CLOSE");
        this.$store.commit('featureInfo/CLEAR_QUERY');
      },
      handleBack () {
        if (this.showBack === 'layers'){
          this.$store.commit('featureInfo/SELECT_QUERY_LAYER', null);
          this.$store.commit('featureInfo/SELECT_QUERY_FEATURE', null);
        }
        if (this.showBack === 'objects'){
          return this.$store.commit('featureInfo/SELECT_QUERY_FEATURE', null);
        }
      },
    },

    data() {
      return {};
    }
  };
</script>

<style scoped>

</style>
